import script from "./userInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./userInfo.vue?vue&type=script&setup=true&lang=js"

import "./userInfo.vue?vue&type=style&index=0&id=4a3e7131&lang=scss"

const __exports__ = script;

export default __exports__